import { LANG_CODE, LanguageCode } from "./constants";

interface LanguageObject {
    [key: string]: any;
}

function importAllLanguageObjects(): LanguageObject {
    const languageObjects: LanguageObject = {};

    const languageRegex = new RegExp(`languages\\/(${LANG_CODE.join('|')})\\/.*\\.ts$`);
    
    const languageFiles = require.context('./../modules', true, /languages\/.*\.ts$/);
    
    languageFiles.keys().forEach((filePath) => {
      if (languageRegex.test(filePath)) {
        const fileName = filePath.replace(/^.*[\\/]/, '').replace(/\.\w+$/, '');
        const languageTypeRegex = new RegExp(`languages\\/(${LANG_CODE.join('|')})\\/`);
        const languageType = filePath.match(languageTypeRegex)?.[1];
        const languageModule = languageFiles(filePath);
    
        if (languageModule.language && languageType) {
          if (!languageObjects[languageType]) {
            languageObjects[languageType] = {};
          }
          languageObjects[languageType][fileName] = languageModule.language;
        }
      }
    });

    return languageObjects;
}

export const languageObjects = importAllLanguageObjects()

export const getValueByKeyPath = (obj: LanguageObject, key: string): any => {
    const keys = key.split('.');
    // console.log(37, keys)
    let value: any = obj;

    for (const k of keys) {
        // eslint-disable-next-line no-prototype-builtins
        if (value && value.hasOwnProperty(k)) {
            value = value[k];
        } else {
            return undefined;
        }
    }
    return value;
}


interface ParamsObject {
    [key: string]: any;
}

function replaceParamsInString(inputString: string, params: ParamsObject): string {
    return inputString.replace(/{(.*?)}/g, (match, key) => {
        // eslint-disable-next-line no-prototype-builtins
        if (params.hasOwnProperty(key.trim())) {
            return params[key.trim()];
        }
        return match; // Giữ nguyên nếu không tìm thấy key trong object
    });
}

export const _t = (key: string, params: any = null): string => {

    let appLang: string = (window as any)._APP_LANG?.toLowerCase()
    if(!LANG_CODE.includes(appLang)) appLang = LanguageCode.vi
    let value = getValueByKeyPath(languageObjects, appLang+'.'+key);
    
    if(params){
        value = replaceParamsInString(value, params)
    }
    // console.log(35, appLang, key, value, languageObjects)
    return value ? value : key
}

